import moment from "moment";
import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { API } from "../constants/env";
import {
  ContainerN,
  WarraperN,
  Title,
  SubTitle,
  NotParagraph,
  Date,
} from "../styles/Notification";

export const Notification = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    fetch(API.notifications.getNotifications, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          console.log(response);
          return swal("Error", response.message, "error");
        }
        console.log("fetching ......");
        setNotifications(response.data);
      })
      .catch((e) => {
        if (e.message === "Failed to fetch") {
          swal("Erreur", "Probléme de connection", "error");
        }
      });
  }, []);

  return (
    <ContainerN>
      {notifications.length !== 0 ? (
        notifications.map((notif) => (
          <WarraperN>
            <Title>
              {notif.title} <Date>({notif.date})</Date>
            </Title>
            <SubTitle>{notif.subTitle}</SubTitle>
            <NotParagraph>{notif.body}</NotParagraph>
          </WarraperN>
        ))
      ) : (
        <h1>no notifications</h1>
      )}
    </ContainerN>
  );
};
